<template>
  <v-list-group>
    <template v-slot:activator>
      <v-list-item-title class="subtitle-2" v-text="text" />
    </template>
    <v-list-item-group>
      <MenuItem
        v-for="item in submenu"
        :key="item.nomor"
        :text="item.text"
        :route="'/form/' + nomor + '/' + item.nomor"
      />
    </v-list-item-group>
  </v-list-group>
</template>
<script>
import MenuItem from "./MenuItem";
export default {
  props: {
    nomor: {
      type: Number,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    submenu: {
      type: Array,
      required: true
    }
  },
  components: { MenuItem }
};
</script>
